import { EntityBase } from './EntityBase';
import { Material } from './Material';
import { MaterialComponent } from './MaterialComponent';

import { Validator } from 'breeze-client';
import * as moment from 'moment-mini';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

export class MaterialComposition extends EntityBase {

   /// <code> Place custom code between <code> tags

   public formattedValidationDate() {
      return (this.validationDate == null) ? '' : moment(this.validationDate).format('L');
   }

   /// </code>

   // Generated code. Do not place code below this line.
   materialCompositionId: number;
   materialId: number;
   materialComponentId: number;
   componentAmount: number;
   componentValue: string;
   validationDate: Date;
   itemCode: string;
   created: Date;
   createdUser: string;
   modified: Date;
   modifyUser: string;
   rowVersion: number;
   material: Material;
   materialComponent: MaterialComponent;
}

